import { z } from "zod";
/**
 * Who the caller is signed in as.
 *
 * Carries only what a surface needs to address the person. Roles and the ICIS
 * identity are deliberately absent: authorisation decisions belong on the
 * routes that need them, not on a shape the client can read.
 */
export const AuthSessionSchema = z.object({
    name: z.string(),
});
